import { useAuth } from '@/hooks/useAuth';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { AlertTriangle } from 'lucide-react';

export const InactivePage = () => {
	const { positionStatus } = useAuth();

	return (
		<div className="min-h-screen bg-blue-50 flex items-center justify-center px-4">
			<Card className="w-full max-w-md shadow-lg">
				<CardHeader className="text-center">
					<div className="mx-auto w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mb-4">
						<AlertTriangle className="w-6 h-6 text-amber-600" />
					</div>
					<CardTitle className="text-xl font-semibold text-gray-900">
						Position Inactive
					</CardTitle>
				</CardHeader>
				<CardContent className="text-center space-y-4">
					<p className="text-gray-600">
						{positionStatus?.title ? (
							<>
								The position "<strong>{positionStatus.title}</strong>" is
								currently inactive.
							</>
						) : (
							'This position is currently inactive.'
						)}
					</p>
					<p className="text-sm text-gray-500">
						Please contact the position administrator for more information about
						when this position will be available again.
					</p>
				</CardContent>
			</Card>
		</div>
	);
};
